export const LADE_PROGRAMME = "ladeProgramme";
